/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
// noinspection JSUnusedGlobalSymbols
export enum ChartColors {
  /// New atomic colors - DARK
  MellowYellowDark = '#DBAE30',
  PaleCopperDark = '#D8673F',
  OldBrickDark = '#AF5250',
  RazzmicBerryDark = '#863C60',
  VividBlueDark = '#276ED9',
  DustyOliveDark = '#9C937D',
  SoftBlueDark = '#274EA0',
  HoneyFlowerDark = '#555787',
  MingDark = '#3D6D71',
  JungleGreenDark = '#2A7A59',
  DarkGunmetalDark = '#201f1F',
  DimGreyDark = '#4C4D52',
  AshGreyDark = '#68696B',
  AshGreyDarkPale = '#4A4B4C',
  WhiteDark = '#F3F2F1',
  // New atomic colors - BRIGH
  MellowYellow = '#FFD426',
  FawnOrange = '#EC9E32',
  FawnOrangeLight = '#F3C07A',
  FawnOrangeDark = '#AD782F',
  PaleCopper = PaleCopperDark,
  PaleCopperLight = '#E69C82',
  OldBrick = OldBrickDark,
  RazzmicBerry = RazzmicBerryDark,
  BittersweetRed = '#C5314B',
  BittersweetRedDark = '#972E43',
  BittersweetRedLight = '#DA798A',
  VividBlue = '#0755CB',
  DustyOlive = '#9C937D',
  SoftBlue = SoftBlueDark,
  HoneyFlower = '#4F5186',
  JungleGreen = '#33946C',
  JungleGreenLight = '#7ABA9F',
  Ming = '#3D6D71',
  MountainMeadow = '#2ABA68',
  MountainMeadowDark = '#258C55',
  MountainMeadowLight = '#74D29D',
  DarkGunmetal = '#1C2129',
  DimGrey = '#686B70',
  AshGrey = '#B3B5B8',
  AshGreyPale = '#d9dadb',
  White = '#FFFFFF',
  Line = '#E8E8E9',
  LineDark = '#1B1A19',
  Font = '#777A7F',
  FontDark = '#A4A3A3',
  TrendLine = '#464873',
  DatabarIndicator = '#707070',
  LegendOff = '#B2B2B2',
  LavenderGray = '#b5b6d3',

  FawnOrangeMountainMeadowTransition = '#8BAC4D',
  BittersweetRedFawnOrangeTransition = '#D9683F',

  FawnOrangeMountainMeadowTransitionDark = '#8AA047',
  BittersweetRedFawnOrangeTransitionDark = '#DC6941',

  HandledCalls = MountainMeadow,
  HandledCallsDark = '#13A862',

  NotHandledCalls = BittersweetRed,
  NothandledCallsDark = '#D9324B',

  AllCalls = '#2f3046',
  RONA = '#DEA60E',
  RONADark = '#E7754E',
  DeclinedCalls = '#BC142E',
  DeclinedCallsDark = '#D9324B',
  HandledNotHandledOverlay = '#FDB913',
  Summary = '#bababa',
  Empty = AshGreyPale,
  EmptyDark = '#201f1f',
  QueueTime = '#2E75B6',
  VoiceMessage = '#0755CB',
  VoiceMessageDark = '#0755CB',

  LineContrast = '#FFFFFF',

  Label = '#AFBDC3',
  LabelDark = '#C8C6C4',
  LabelContrast = '#FFFFFF',

  Available = HandledCalls,
  AvailableDark = '#1A7A4A',

  Enabled = '#219a46',
  EnabledDark = '#13A862',

  NotAvailable = NotHandledCalls,
  NotAvailableDark = NothandledCallsDark,

  Disabled = '#8D8D9A',
  DisabledDark = '#4c4c55',
  PurpleMedium = '#464775',

  CallConnected = LavenderGray,
  CallConnectedDark = '#5B5C80',

  CallInQueue = '#7778ad',
  CallInQueueDark = '#464873',

  CallInIVR = PurpleMedium,
  CallInIVRDark = '#3C3D54',

  AllConversations = PurpleMedium,

  HangupInIVR = '#ED941B',
  HangupInIVRDark = '#D9324B',

  HangupInQueue = NotAvailable,
  HangupInQueueDark = '#E7754E',

  HangupBeforeAccept = '#F0CD0B',
  HangupBeforeAcceptDark = '#D4BE5D',

  Reachability = '#464775',
  ReachabilityDark = '#646675',

  AcceptanceSLA = '#8FD0DB',
  AcceptanceSLADark = '#8FD0DB',

  HangupSLA = '#1FA0B7',
  HangupSLADark = '#1FA0B7',

  HangupByWorkflow = '#961D30',

  SwitchboardEnabled = '#219a46',
  SwitchboardDisabled = '#8D8D9A',

  CalendarOpen = '#13A862',
  CalendarHoliday = '#5B5C80',
  CalendarClosed = '#D9324B',
  CalendarSpecial = '#6071F0',
  CalendarSpecial2 = '#863C60',
  CalendarSpecial3 = '#D8673F',
  CalendarSpecial4 = '#1C2129',

  Uncompleted = LavenderGray,
  Suspended = AshGrey,
  ServicesRunning = VividBlue,
  PSTNRunning = HoneyFlower,
  ServicesApplied = MountainMeadow,
  PSTNApplied = JungleGreen,
  Warning = BittersweetRed,

  PresenceStatusOffline = '#686b70',
  PresenceStatusOfflineDark = '#4c4d52',
  PresenceStatusAvailable = '#2aba68',
  PresenceStatusAvailableDark = '#28a15c',
  PresenceStatusAway = '#ec9e32',
  PresenceStatusAwayDark = '#ec9e32',
  PresenceStatusBusy = '#c5314b',
  PresenceStatusBusyDark = '#cc334f',

  ResponsibilityProfileTypeDuty = '#2aba68',
  ResponsibilityProfileTypeDutyDark = '#28a15c',
  ResponsibilityProfileTypeOffDuty = '#686b70',
  ResponsibilityProfileTypeOffDutyDark = '#4c4d52',

  DutyPresenceAvailable = '#2aba68',
  DutyPresenceAvailableDark = '#28a15c',
  DutyPresenceNotAvailable = '#c5314b',
  DutyPresenceNotAvailableDark = '#cc334f',
  DutyPresenceOffDuty = '#686b70',
  DutyPresenceOffDutyDark = '#4c4d52',
}

export const ChartSeriesColors: ReadonlyArray<readonly [light: ChartColors, dark: ChartColors]> = [
  [ChartColors.VividBlue, ChartColors.VividBlueDark],
  [ChartColors.MountainMeadow, ChartColors.MountainMeadowDark],
  [ChartColors.MellowYellow, ChartColors.MellowYellowDark],
  [ChartColors.PaleCopper, ChartColors.PaleCopperDark],
  [ChartColors.RazzmicBerry, ChartColors.RazzmicBerryDark],
  [ChartColors.Ming, ChartColors.MingDark],
  [ChartColors.HoneyFlower, ChartColors.HoneyFlowerDark],
  [ChartColors.JungleGreen, ChartColors.JungleGreenDark],
  [ChartColors.OldBrick, ChartColors.OldBrickDark],
  [ChartColors.SoftBlue, ChartColors.SoftBlueDark],
  [ChartColors.FawnOrange, ChartColors.FawnOrangeDark],
  [ChartColors.BittersweetRed, ChartColors.BittersweetRedDark],
];
